import { Request } from '../../../httpClient/serverApi/requests/Request';
import {IResult} from '../../../httpClient/serverApi/types/IResponse';

export interface IGetHasScriptCalcParams {
  // the ID of the workbook that we are checking for script calcs
  id: string;
}

export interface IGetHasScriptCalcResult extends IResult{}

export class GetHasScriptCalcRequest extends Request<IGetHasScriptCalcParams, IGetHasScriptCalcResult> {
  constructor(params: IGetHasScriptCalcParams) {
    super('getHasScriptCalc', params);
  }
}